module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-5"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Thirty minutes after the ladies left, there was still no money going into the cash drawer. I’d experienced a good opportunity to buy merchandise, but it was sad in a way to reap the profits of someone who must give up her treasures. I was eating a bite of lunch when a young woman came into the shop. She was very attractive and appeared friendly.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Hi, Lily. I’m Susan from the library. I understand that you came in and asked for me and I wasn’t there that day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh! It’s nice to meet you, Susan. When I came to see you initially, I was looking for a place to live. Now, I could use some help learning about the doctor who once owned this house. I’ve been busy getting this shop open, so I haven’t had time to continue my research.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I keep up with your progress through Betty Bade. She comes to the library a lot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I see! Betty was my very first customer. I met her through Carrie Mae.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, they are longtime friends. I was curious about your quilts that I keep hearing about. I love quilts, and you may have heard that I teach quilting to a small group of ladies at the library.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You do? I’m not a quilter but have great appreciation for those who are. I am partial to antique quilts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I love them, too!” she said as we gravitated toward the quilt room. “My goodness, you have a lot of them. I love the scrappy quilts. I grew up with them, and I love seeing how the quilters used what they had. Some aren’t that pretty, but they all tell a story.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You are so right. I personally like simpler patterns constructed with two colors. My friend knows a lot about quilts, and she says to always date a quilt by the newest fabric that was used in it. She loves to research patterns and then do lectures.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m curious about the price on the blue-and-red Nine-Patch quilt,” she mentioned as she looked at the tag. “I like that the quiltmaker threw in some black, which actually works surprisingly well. She was a creative person, I think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Let’s open it up. That way, you really get the whole effect of the design. I love some black in a quilt as well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, I have to take it home. The price is so reasonable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’ll give you the professional courtesy discount that I give to other business folks.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("She beamed. “Thanks so much! I understand that you live upstairs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, it’s pretty handy,” I said as I wrote up her sale. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, add this little child’s tin cup as well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’ll be back to visit the library as soon as I get past the holidays. I’m going out of town for Christmas and I also have a lot going on here with workmen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I see. I would like to invite you to our little quilting ")]), _c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("group so you can meet everyone. They would love to talk to you about quilts as a retailer. Who knows? You may decide to quilt a stitch or two! We meet every Monday at ten, just for an hour or so. You can just show up whenever you like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("“You are so nice to invite me, Susan. I can’t promise anything right now. I have a shop to open at ten.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("“Most shops don’t open on Mondays, especially through the winter, so that’s an opportunity for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("“I’ll consider that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("“It’s a fun group, and you’ll learn something too. I can’t wait to get this quilt home. Thanks for the discount.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  }, [_vm._v("Off she went, and I felt I had made an acquaintance as well as a happy customer.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "bodytext4"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10989dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split8.vue
// module id = 84
// module chunks = 0